(function () {
    const header = document.querySelector('.tms-header.has-background-image');
    const services = document.querySelector('.tms-podcast-service-list');
    if (!header || !services) return;

    header.style.setProperty('--services-height', `${services.offsetHeight}px`);
})();

(function () {
    pagination(true);
})();
